export const FORM_FIELD = {
  VOCABULARIES: {
    name: 'vocabularies',
  },
};
